export default "__VITE_ASSET__Z4SE9BNT__"